import React, { Dispatch } from 'react';
import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    styled,
    Typography,
    Backdrop,
    CircularProgress,
    Box
} from '@mui/material';

import { CaseProcedureModel } from '../../../lib/models/CaseProcedureModel';
import theme from '../../../theme';
import InitialReviewProcedureItem from './InitialReviewProcedureItem/InitialReviewProcedureItem';
import { useGet } from '../../../lib/api/hooks';
import { DecisionReasonModel } from '../../../lib/models/DecisionReasonModel';
import { useScreenSmallerThan } from '../../../lib/hooks/breakpoint-hooks';
import { backdropStyle } from '../../../style';

export type CaseProcedureListingProps = {
    procedureList: CaseProcedureModel[] | undefined;
    crmId: string | undefined;
    crmClientName?: string;
    caseStage: string;
    // eslint-disable-next-line
    handleReasonDenialChange: any;
    setAnyChangeMade: Dispatch<boolean>;
};

function InitialReviewProcedureListing({
    procedureList,
    crmId,
    crmClientName,
    caseStage,
    handleReasonDenialChange,
    setAnyChangeMade
}: CaseProcedureListingProps) {
    const { data, loading } = useGet<DecisionReasonModel[]>(
        `decisionreason/getlist?crmId=${crmId}`
    );
    const isSmallerThanSmall = useScreenSmallerThan('sm');
    const isSmallerThanLarge = useScreenSmallerThan('lg');

    const TableHeaderCell = styled(TableCell)({
        color: theme.palette.cardSubtitle.main,
        fontSize: 13,
        borderBottom: 'none'
    });

    return !loading ? (
        data != null ? (
            <>
                {!isSmallerThanSmall && !isSmallerThanLarge ? (
                    <>
                        <TableContainer sx={{ padding: '20px', paddingTop: '10px' }}>
                            <Table
                                sx={{
                                    background: 'white',
                                    borderRadius: !isSmallerThanSmall ? '10px' : '0'
                                }}>
                                <TableHead>
                                    <TableRow>
                                        <TableHeaderCell>Requested Code</TableHeaderCell>
                                        <TableHeaderCell>Description</TableHeaderCell>
                                        <TableHeaderCell>Units</TableHeaderCell>
                                        <TableHeaderCell>Nurse Recommendation</TableHeaderCell>
                                        <TableHeaderCell>
                                            Code Decision
                                            <Typography sx={{ color: 'red', display: 'inline' }}>
                                                *
                                            </Typography>
                                        </TableHeaderCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {procedureList != null && procedureList.length > 0
                                        ? procedureList.map((item, index) => (
                                              <InitialReviewProcedureItem
                                                  key={index}
                                                  item={item}
                                                  crmClientName={crmClientName}
                                                  reasons={data}
                                                  caseStage={caseStage}
                                                  handleReasonDenialChange={
                                                      handleReasonDenialChange
                                                  }
                                                  setAnyChangeMade={setAnyChangeMade}
                                              />
                                          ))
                                        : null}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                ) : (
                    <Box
                        sx={{
                            background: 'white',
                            borderRadius: !isSmallerThanSmall ? '0.625rem' : '0',
                            marginBottom: '0.875rem',
                            padding: '0.625rem',
                            margin: isSmallerThanSmall ? '0' : '1.25rem'
                        }}>
                        {procedureList != null && procedureList.length > 0
                            ? procedureList.map((item, index) => (
                                  <InitialReviewProcedureItem
                                      key={index}
                                      item={item}
                                      crmClientName={crmClientName}
                                      reasons={data}
                                      caseStage={caseStage}
                                      handleReasonDenialChange={handleReasonDenialChange}
                                      setAnyChangeMade={setAnyChangeMade}
                                  />
                              ))
                            : null}
                    </Box>
                )}
            </>
        ) : (
            <Box></Box>
        )
    ) : (
        <>
            <Backdrop sx={backdropStyle} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default InitialReviewProcedureListing;
